// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-active {
  background: #be1e2d;
  opacity: 0.75;
  height: 46px;
  --border-color: #be1e2d !important;
  --ion-background-color: #be1e2d !important;
}

ion-header {
  background-color: #be1e2d !important;
}

ion-item {
  --border-style: none;
  --border-color: black !important;
  --border-width: 0px !important;
  --inner-padding-end: 0px;
  --padding-start: 0px;
  padding: 0px 10px;
  cursor: pointer;
}

ion-toggle {
  --background: #dedede;
  --background-checked: #c8dcff;
  --handle-background-checked: #be1e2d;
}

ion-toolbar[appAllowOverflow] {
  padding: 0px;
}

.text-center {
  text-align: center;
}

.ion-side-menu {
  background: white;
}

.custom-menu {
  --width: 250px;
}

.switch-button {
  padding: 10px 20px;
  border: 1px solid white;
  color: white;
  background: transparent;
  text-align: center;
  font-size: 17px;
  border-radius: 5px;
  margin: 12px 0px;
}

.player-img {
  width: 50px;
  height: 50px;
  border-radius: 30px;
}

.margin-top {
  margin-top: 15px;
}

.logout-button {
  float: right;
}

.organization-name,
.user-name {
  color: white;
  margin: 10px 0px 0px 55px;
}

.player-image {
  width: 40px;
  height: 40px;
  border-radius: 30px;
}

.text-left {
  text-align: left;
}

.organization-logo {
  max-width: 20%;
}

.check-mark {
  margin-right: -13px;
  margin-top: 9px;
  float: right;
  font-size: 25px;
  color: red;
}

.scroll-content {
  overflow-y: hidden;
}

ion-backdrop {
  cursor: auto !important;
}

[tappable] {
  cursor: auto !important;
}

ion-label.label.label-md {
  text-align: left !important;
}

.log-user {
  padding: 1px 0px;
  background: #be1e2d;
  padding-top: calc(1px + env(safe-area-inset-top)) !important;
}

.log-user p {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: white;
  text-transform: capitalize;
}

.sync {
  font-size: 16px;
}

.item-cover {
  background: transparent !important;
}

span.newLabel {
  font-size: 10px;
  color: red;
  top: 15px;
  position: absolute;
  left: 35px;
}

span.newGameLabel {
  font-size: 10px;
  color: red;
  top: 15px;
  position: absolute;
  left: 36%;
}

ion-menu ion-content.ion-side-menu ion-list {
  background: white;
  color: black;
  --background: white;
  --color: black;
}

ion-menu ion-content.ion-side-menu ion-list ion-item {
  background: white;
  color: black;
  --background: white;
  --color: black;
  padding: 0px 15px !important;
}

ion-item[_ngcontent-ggo-c138] {
  --border-style: none;
  --border-color: white !important;
  --border-width: 0px !important;
  --inner-padding-end: 0px;
  --padding-start: 0px;
  padding: 0px 15px !important;
}

.sync-btn {
  position: absolute;
  bottom: 5px;
  right: 0;
  border-radius: 16px;
}

.highlight-active {
  color: #be1e2d !important;
  --color: #be1e2d !important;
  font-weight: bold;
}

.share-model .modal-wrapper {
  height: 290px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kCAAA;EACA,0CAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAEA;EACI,oBAAA;EACA,gCAAA;EACA,8BAAA;EACA,wBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,qBAAA;EACA,6BAAA;EACA,oCAAA;AACJ;;AAEA;EAEE,YAAA;AAAF;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;;EAEI,YAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAAJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;EACA,4DAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,0BAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,kCAAA;AACJ;;AAEA;EACI,eAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AACJ;;AAEA;EACI,eAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;AACJ;;AAEA;EACI,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,4BAAA;AACJ;;AACA;EACI,oBAAA;EACA,gCAAA;EACA,8BAAA;EACA,wBAAA;EACA,oBAAA;EACA,4BAAA;AAEJ;;AACA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;AAEJ;;AACA;EACI,yBAAA;EACA,2BAAA;EACA,iBAAA;AAEJ;;AAAA;EACI,wBAAA;AAGJ","sourcesContent":[".header-active {\n    background: #be1e2d;\n    opacity: 0.75;\n    height: 46px;\n    --border-color: #be1e2d !important;\n    --ion-background-color: #be1e2d !important;\n}\n\nion-header{\n    background-color: #be1e2d !important;\n}\n\nion-item {\n    --border-style: none;\n    --border-color: black !important;\n    --border-width: 0px !important;\n    --inner-padding-end: 0px;\n    --padding-start: 0px;\n    padding: 0px 10px;\n    cursor: pointer;\n}\n\nion-toggle {\n    --background: #dedede;\n    --background-checked: #c8dcff;\n    --handle-background-checked: #be1e2d;\n}\n\nion-toolbar[appAllowOverflow]\n{\n  padding : 0px;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.ion-side-menu {\n    background: white;\n}\n\n.custom-menu {\n    --width: 250px;\n}\n\n.switch-button {\n    padding: 10px 20px;\n    border: 1px solid white;\n    color: white;\n    background: transparent;\n    text-align: center;\n    font-size: 17px;\n    border-radius: 5px;\n    margin: 12px 0px;\n}\n\n.player-img {\n    width: 50px;\n    height: 50px;\n    border-radius: 30px;\n}\n\n.margin-top {\n    margin-top: 15px;\n}\n\n.logout-button {\n    float: right;\n}\n\n.organization-name,\n.user-name {\n    color: white;\n    margin: 10px 0px 0px 55px;\n}\n\n.player-image {\n    width: 40px;\n    height: 40px;\n    border-radius: 30px;\n}\n\n.text-left {\n    text-align: left;\n}\n\n.organization-logo {\n    max-width: 20%;\n}\n\n.check-mark {\n    margin-right: -13px;\n    margin-top: 9px;\n    float: right;\n    font-size: 25px;\n    color: red;\n}\n.scroll-content {\n    overflow-y: hidden;\n}\n\nion-backdrop {\n    cursor: auto !important;\n}\n\n[tappable] {\n    cursor: auto !important;\n}\n\nion-label.label.label-md {\n    text-align: left !important;\n}\n\n.log-user {\n    padding: 1px 0px;\n    background: #be1e2d;\n    padding-top: calc(1px + env(safe-area-inset-top)) !important;\n}\n\n.log-user p {\n    font-size: 16px;\n    font-weight: bold;\n    text-align: center;\n    color: white;\n    text-transform: capitalize;\n}\n\n.sync {\n    font-size: 16px;\n}\n\n.item-cover {\n    background: transparent !important;\n}\n\nspan.newLabel {\n    font-size: 10px;\n    color: red;\n    top: 15px;\n    position: absolute;\n    left: 35px;\n}\n\nspan.newGameLabel {\n    font-size: 10px;\n    color: red;\n    top: 15px;\n    position: absolute;\n    left : 36%;\n}\n\nion-menu ion-content.ion-side-menu ion-list {\n    background: white;\n    color: black;\n    --background: white;\n    --color: black;\n}\n\nion-menu ion-content.ion-side-menu ion-list ion-item {\n    background: white;\n    color: black;\n    --background: white;\n    --color: black;\n    padding: 0px 15px !important;\n}\nion-item[_ngcontent-ggo-c138] {\n    --border-style: none;\n    --border-color: white !important;\n    --border-width: 0px !important;\n    --inner-padding-end: 0px;\n    --padding-start: 0px;\n    padding: 0px 15px !important;\n}\n\n.sync-btn {\n    position: absolute;\n    bottom: 5px;\n    right: 0;\n    border-radius: 16px;\n}\n\n.highlight-active {\n    color: #be1e2d !important;\n    --color: #be1e2d !important;\n    font-weight: bold;\n}\n.share-model .modal-wrapper {\n    height: 290px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
